import mutations from './mutations';
import api from '../api';

export default {
  namespaced: true,
  state: {
    loading: false,
    divisions: []
  },
  mutations: {
    [mutations.LOADING](state) {
      state.loading = true;
    },
    [mutations.LOADED](state) {
      state.loading = false;
    }
  },
  actions: {
    getAll({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.dynamic
        .getAll(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    getHierarchy({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.dynamic
        .getHierarchy(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    getDraftHierarchy({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.dynamic
        .getDraftHierarchy(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    detailHierarchy({ commit }, id) {
      commit(mutations.LOADING);
      return api.dynamic
        .detailHierarchy(id)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    },
    detailDraftHierarchy({ commit }, id) {
      commit(mutations.LOADING);
      return api.dynamic
        .detailDraftHierarchy(id)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    },
    detailGroup({ commit }, id) {
      commit(mutations.LOADING);
      return api.dynamic
        .detailGroup(id)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    },
    getGroup({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.dynamic
        .getGroup(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    getBO({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.dynamic
        .getBO(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    createGroup({ commit }, payload) {
      commit(mutations.LOADING);
      return api.dynamic
        .createGroup(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    updateGroup({ commit }, { id, params }) {
      commit(mutations.LOADING);
      return api.dynamic
        .updateGroup(id, params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    },
    updateDraft({ commit }, { id, params }) {
      commit(mutations.LOADING);
      return api.dynamic
        .updateDraft(id, params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    },
    updateApply({ commit }, { id, params }) {
      commit(mutations.LOADING);
      return api.dynamic
        .updateApply(id, params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    },
    deleteGroup({ commit }, id) {
      commit(mutations.LOADING);
      return api.dynamic
        .deleteGroup(id)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    },
    createHierarchy({ commit }, payload) {
      commit(mutations.LOADING);
      return api.dynamic
        .createHierarchy(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    applyHierarchy({ commit }, payload) {
      commit(mutations.LOADING);
      return api.dynamic
        .applyHierarchy(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    createDraft({ commit }, payload) {
      commit(mutations.LOADING);
      return api.dynamic
        .createDraft(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    getLevel({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.dynamic
        .getLevel(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    saveLevel({ commit }, payload) {
      commit(mutations.LOADING);
      return api.dynamic
        .saveLevel(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    }
  },
  getters: {
    isLoggedIn: state => state.isLoggedIn,
    user: state => state.user,
    token: state => state.token,
    isLoading: state => state.loading,
    error: state => {
      if (state.error && state.error.response) {
        return state.error.response.data;
      }
      return state.error;
    }
  }
};
